
export default function Hero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-24">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/d6c1b7c88b0298bf5eca8a5972a546bf.jpg')] bg-cover bg-center opacity-20"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Get in Touch with TMI
          </h1>
          <p className="text-xl text-slate-300 mb-8">
            Ready to discuss your mining or logistics needs? Our team is here to help you find the perfect solution for your business.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-lg">
            <div className="flex items-center gap-2">
              <i className="ri-phone-line text-teal-400"></i>
              <span>24/7 Support</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-mail-line text-teal-400"></i>
              <span>Quick Response</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-map-pin-line text-teal-400"></i>
              <span>Southern Africa Coverage</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
